import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import 'hammerjs';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './/app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './auth/auth.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuard } from './auth/auth.guard';
import { AuthHttpInterceptor } from './auth/AuthHttpInterceptor';
import { MaterialModule } from './/material.module';
import { InicioModule } from './inicio/inicio.module';
import { ImpuestosModule } from './impuestos/impuestos.module';
import { PagosModule } from './pagos/pagos.module';
import { HistorialpagosModule } from './historialpagos/historialpagos.module';
import { AdherirmailModule } from './adherirmail/adherirmail.module';
import { Proveedor } from './inicio/proveedores/proveedorModel';



@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    InicioModule,
    ImpuestosModule,
    PagosModule,
    HistorialpagosModule,
    AdherirmailModule
    
  ],
  providers: [AuthService, AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
